import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import Pagination from "./pagination.jsx";
const API_URL = import.meta.env.VITE_API_URL;

const ShowPassages = ({passages, preparePlate, clickedResult, selectedIndex, links, search}) => {
    return (
        <div className={"col-span-9"}>
            <div className="flex flex-col relative h-full">
                <div className="flex-1 overflow-y-auto p-2">
                    <div className="grid grid-cols-12 gap-2">
                        {passages.length > 0 && passages.map((p, index) => {
                            let plateDisplay = preparePlate(p.plate)
                            const url = p.imageUrl;

                            return (
                                <div key={index} className="col-span-12 sm:col-span-6 lg:col-span-3 cursor-pointer" onClick={() => clickedResult(index, url, p)}>
                                    <Card className={`${selectedIndex === index ? "border border-black" : "border border-[#dcdcdc]!"}`}>
                                        <Card.Body>
                                            <div className="flex flex-col w-full">
                                                <div
                                                    id="lane"
                                                    className="text-center h-[45px] overflow-hidden"
                                                    dangerouslySetInnerHTML={{ __html: p.lane.name }}
                                                />
                                                <hr className="border-0 h-px bg-gradient-to-r from-transparent via-[#a2a4a5] to-transparent mt-0 mb-[3px]" />

                                                <div className="text-center mb-[3px] vehicle-date-passage">
                                                    {p.captureTime}
                                                </div>

                                                <div className="text-center p-0 bg-white text-[#bebec3] font-semibold h-[102px]">
                                                    <img
                                                        src={`${API_URL}/${url}`}
                                                        className="img-passage max-h-[102px] mx-auto"
                                                        alt="Passagem"
                                                    />
                                                </div>

                                                <div className="flex justify-around product-desc mt-2">
                                                    <div className="vehicle-plate">
                                                        <div className={`product-heading ${p.plate.pattern ?? 'WITHOUT_PATTERN'}`}></div>
                                                        <div className={`product-body ${p.plate.pattern ?? 'WITHOUT_PATTERN'}`}>
                                                            {plateDisplay}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            )
                        })}
                    </div>
                </div>

                {(links.length > 0 && passages.length > 0) && (
                    <div className="sticky bottom-0 w-full bg-[#F3F4F6] backdrop-blur-md z-20 py-2">
                        <div className="flex justify-center">
                            <Pagination links={links} onSearch={search} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ShowPassages;